/**
 * API base URL for backend requests.
 * Use this so cart/place-order and other API calls work on live/E2E when
 * REACT_APP_API_URL is not set at build time (e.g. same-origin or injected).
 *
 * Priority:
 * 1. process.env.REACT_APP_SKIN_API_URL (build-time, skin-specific)
 * 2. process.env.REACT_APP_API_URL (build-time, shared)
 * 3. window.NYAFAZ_SKIN_API_URL (injected, skin-specific)
 * 4. window.NYAFAZ_API_URL (injected, shared)
 * 5. window.REACT_APP_SKIN_API_URL (injected, skin-specific)
 * 6. window.REACT_APP_API_URL (injected, shared)
 * 7. Dev fallback: when app is on localhost:3000, use localhost:5001 (skin backend)
 * 8. window.location.origin (same-origin when app and API are on same host)
 */
const DEFAULT_DEV_API_ORIGIN = 'http://localhost:5001';

export function getApiBaseUrl() {
  const fromSkinEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_SKIN_API_URL;
  if (fromSkinEnv && String(fromSkinEnv).trim()) return String(fromSkinEnv).trim().replace(/\/$/, '');

  const fromEnv = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL;
  const normalizedFromEnv = fromEnv && String(fromEnv).trim() ? String(fromEnv).trim().replace(/\/$/, '') : '';

  if (typeof window !== 'undefined') {
    const fromWindow =
      window.NYAFAZ_SKIN_API_URL ||
      window.NYAFAZ_API_URL ||
      window.REACT_APP_SKIN_API_URL ||
      window.REACT_APP_API_URL;
    if (fromWindow && String(fromWindow).trim()) return String(fromWindow).trim().replace(/\/$/, '');

    const origin = window.location && window.location.origin;
    if (origin && (origin === 'http://localhost:3000' || origin === 'https://localhost:3000')) {
      // Shared API URL is often configured for legacy monolith (5000); skin runs on 5001.
      if (normalizedFromEnv === 'http://localhost:5000' || normalizedFromEnv === 'https://localhost:5000') {
        return DEFAULT_DEV_API_ORIGIN;
      }
      if (normalizedFromEnv) return normalizedFromEnv;
      return DEFAULT_DEV_API_ORIGIN;
    }

    if (origin && /analyze\.nyafaz\.com$/i.test(new URL(origin).hostname)) {
      return origin;
    }

    if (normalizedFromEnv) return normalizedFromEnv;
    if (origin) return origin;
  }

  if (normalizedFromEnv) return normalizedFromEnv;

  return '';
}

/** Skin frontend: Flask routes are mounted under `/api/*` (see backend/skin). */
export const SKIN_API_PREFIX = '/api';

/**
 * Backward compatibility alias.
 * Some legacy modules may still import SALON_API_PREFIX from skin utils by mistake.
 */
export const SALON_API_PREFIX = SKIN_API_PREFIX;
